import script from "./ControlViewTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlViewTwo.vue?vue&type=script&setup=true&lang=js"

import "./ControlViewTwo.vue?vue&type=style&index=0&id=007f7028&lang=css"

const __exports__ = script;

export default __exports__